// src/contexts/BranchContext.jsx

import React, { createContext, useContext, useState, useEffect } from 'react';

// Context 생성
const BranchContext = createContext();

// Provider 컴포넌트 생성
export function BranchProvider({ children }) {
    // 초기값: 로컬 스토리지에 저장된 값이 있으면 그거 쓰고, 없으면 기본값(null 또는 삼성점 등)
    const [currentBranch, setCurrentBranch] = useState(() => {
        const saved = localStorage.getItem('selectedBranch');
        return saved ? JSON.parse(saved) : {
            brKey: '',
            brName: '',
            isProductAvailable: 'N',
            availableStKinds: ['E'], // 기본값으로 슬릭부스트 노출
            footerInfo: {
                companyName: '',
                ceoName: '',
                businessNumber: '',
                ecommerceNumber: '',
                address: '',
                csPhone: '',
                email: ''
            }
        };
    });

    // 지점이 변경될 때마다 로컬 스토리지도 업데이트
    useEffect(() => {
        if (currentBranch) {
            localStorage.setItem('selectedBranch', JSON.stringify(currentBranch));
        }
    }, [currentBranch]);

    // 지점 변경 함수
    const selectBranch = (branch) => {
        setCurrentBranch(branch);
    };

    return (
        <BranchContext.Provider value={{ currentBranch, selectBranch }}>
            {children}
        </BranchContext.Provider>
    );
}

// 커스텀 훅 (각 페이지에서 편하게 쓰기 위함)
export function useBranch() {
    const context = useContext(BranchContext);
    if (!context) {
        throw new Error('useBranch must be used within a BranchProvider');
    }
    return context;
}